// extracted by mini-css-extract-plugin
export var container = "_ot-0";